import { createSelector } from 'reselect'

import { isObject } from 'shared/helpers/obj_helpers'
import { NEW_CAMPAIGN_ID } from 'redux/modules/campaign'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'
import { getMainCategory } from 'client/lib/category'

const { CROWD_FUNDING, PUBLIC_MONEY_POOL } = POOLS_CAMPAIGN_TYPES

export const getCurrentUserId = state => {
  return state.current_user && state.current_user.id
    ? state.current_user.id
    : ''
}
export const getCampaigns = state => state.campaign

export const getCampaignFromProps = (state, { campaignId }) => {
  return state.campaign[campaignId]
}
const getCampaignFromLastCreationId = state =>
  state.campaign[state.campaign.last_creation_id]

export const getLastCreatedCampaignSelector = createSelector(
  getCampaignFromLastCreationId,
  campaign => campaign
)

export const getCampaignSelector = createSelector(
  getCampaignFromProps,
  campaign => campaign
)

export const getNewCampaignSelector = createSelector(
  getCampaigns,
  campaigns => {
    return campaigns[NEW_CAMPAIGN_ID]
  }
)

function isValidCampaign(campaign) {
  if (!isObject(campaign)) {
    return false
  }

  if (campaign.deleted || campaign.id === NEW_CAMPAIGN_ID) {
    return false
  }

  return true
}

export const allCampaignsSelector = createSelector(getCampaigns, campaigns => {
  let allCampaigns = Object.values(campaigns).filter(isValidCampaign)

  // campaign2 is before campaign1 so that it will be sorted in descending order
  allCampaigns.sort(
    (campaign1, campaign2) =>
      new Date(campaign2.start_date).valueOf() -
      new Date(campaign1.start_date).valueOf()
  )

  allCampaigns.forEach(campaign => {
    campaign.category = getMainCategory(campaign.category)
  })
  return allCampaigns
})

export const isGNSelector = createSelector(getCampaignSelector, campaign => {
  const hasCrowdfinding = Boolean(
    campaign && campaign.campaign_type === CROWD_FUNDING
  )
  const hasCharity = Boolean(campaign && campaign.charity)

  if (hasCharity) {
    return false
  }
  return hasCrowdfinding
})

export const isGNCSelector = createSelector(getCampaignSelector, campaign => {
  const hasCrowdfinding = Boolean(
    campaign && campaign.campaign_type === CROWD_FUNDING
  )
  const hasCharity = Boolean(campaign && campaign.charity)

  if (!hasCharity) {
    return false
  }
  return hasCrowdfinding
})

export const isMoneyPoolSelector = createSelector(
  getCampaignSelector,
  campaign => {
    return Boolean(campaign && campaign.campaign_type === PUBLIC_MONEY_POOL)
  }
)

export const getCampaignCategorySelector = createSelector(
  getCampaignFromProps,
  campaign => {
    if (!campaign || !campaign.category) {
      return undefined
    }
    return campaign.category
  }
)

export const getPersonalizationStudioBannerSelector = createSelector(
  state => state.personalizationStudio.banner,
  banner => banner || {}
)

export const getAllowEntryBannerSelector = createSelector(
  getPersonalizationStudioBannerSelector,
  isMoneyPoolSelector,
  (banner, isMoneyPool) => {
    const { bannerIcon, bannerButtonText, bannerLink, bannerTitleText } = banner
    if (isMoneyPool) {
      return Boolean(bannerTitleText && bannerLink)
    }
    return Boolean(
      bannerIcon && bannerButtonText && bannerLink && bannerTitleText
    )
  }
)
